import { AUString } from '@/pages/opinion/utils';
import { useMemo } from 'react';
import { useIntl } from 'umi';

export default function useConstantText({ filter, gameInfo }: any) {
  const curAUString = AUString(filter?.date_type);
  const { formatMessage } = useIntl();
  const filters = useMemo(() => {
    let { entity_type } = gameInfo;
    if (filter.date_type === 'hourly') return [];
    let map: any = {
      mobile: [
        {
          text: formatMessage({ id: 'Mentions & Sentiment' }),
          value: '0',
        },
        {
          text: formatMessage({
            id: `Mentions & ${curAUString} REV DLS`,
          }),
          value: '1',
          children: [
            {
              text: curAUString,
              value: 'DAU',
            },
            {
              text: 'Revenue',
              value: 'Revenue',
            },
            {
              text: 'Download',
              value: 'Download',
            },
          ],
        },
        {
          text: formatMessage({
            id: `Sentiment & ${curAUString} REV DLS`,
          }),
          value: '2',
          children: [
            {
              text: curAUString,
              value: 'DAU',
            },
            {
              text: 'Revenue',
              value: 'Revenue',
            },
            {
              text: 'Download',
              value: 'Download',
            },
          ],
        },
      ],
      pc: [
        {
          text: formatMessage({ id: 'Mentions & Sentiment' }),
          value: '0',
        },
        {
          value: '1',
          text: formatMessage({ id: 'Mentions & PCU DigitalREV Units' }),
          children: [
            {
              text: 'PCU',
              value: 'pcu',
            },
            {
              text: 'Digital Revenue ($)',
              value: 'pcRevenue',
            },
            {
              text: 'Units',
              value: 'units',
            },
          ],
        },
        {
          value: '2',
          text: formatMessage({ id: 'Sentiment & PCU DigitalREV Units' }),
          children: [
            {
              text: 'PCU',
              value: 'pcu',
            },
            {
              text: 'Digital Revenue ($)',
              value: 'pcRevenue',
            },
            {
              text: 'Units',
              value: 'units',
            },
          ],
        },
      ],
      console: [
        {
          text: formatMessage({ id: 'Mentions & Sentiment' }),
          value: '0',
        },
        {
          value: '1',
          text: formatMessage({ id: 'Mentions & PCCV DigitalREV' }),
          children: [
            {
              text: 'Peak CCV',
              value: 'ccv',
            },
            {
              text: 'Digital Revenue ($)',
              value: 'pcRevenue',
            },
          ],
        },
        {
          value: '2',
          text: formatMessage({ id: 'Sentiment & PCCV DigitalREV' }),
          children: [
            {
              text: 'Peak CCV',
              value: 'ccv',
            },
            {
              text: 'Digital Revenue ($)',
              value: 'pcRevenue',
            },
          ],
        },
      ],
    };
    return map[entity_type];
  }, [curAUString, filter, formatMessage]);

  const titleMap: any = {
    Revenue: 'Revenue',
    Download: 'Download',
    ccv: 'Peak CCV',
    pcu: 'PCU',
    pcRevenue: 'Digital Revenue ($)',
    units: 'Units',
  };

  const getTitleOneText = (value: string) => {
    return titleMap[value] || value;
  };

  return {
    filters,
    getTitleOneText,
  };
}
